import { buildService } from './decorated-service';
import settings from '../../../settings.json';

const HouseholdService = buildService('/nasu-svc/service/household');
const HouseholdTierService = buildService(
  '/nasu-svc/service/householdAssetTier'
);
const HouseholdBalanceTierService = buildService(
  '/nasu-svc/service/householdbalancetier'
);
const HouseholdByTaxIdService = buildService(
  '/nasu-svc/service/household/payload'
);
const errorCodes = [204, 400, 404, 500];

const emptyHouseholdData = {
  householdBalanceTierStatus: {
    householdAssetTier: {
      id: 0,
      name: 'NONE',
      maximumAmount: 0,
      minimumAmount: 0
    }
  }
};

const handleServiceResponse = async (): Promise<any> => emptyHouseholdData;

/* export const mockHouseholdData = {
  householdBalanceTierStatus: {
    householdAssetTier: {
      id: 3,
      name: 'Select',
      demotionThresholdDays: 0,
      demotionThresholdPercentage: 0,
      effectiveDate: null,
      expirationDate: null,
      maximumAmount: 499999.9999,
      minimumAmount: 250000
    }
  }
}; */

export const mockHouseholdData = {
  householdBalanceTierStatus: {
    householdAssetTier: {
      id: 4,
      name: 'Personal Services',
      demotionThresholdDays: 0,
      demotionThresholdPercentage: 0,
      effectiveDate: null,
      expirationDate: null,
      maximumAmount: 999999.9999,
      minimumAmount: 500000
    }
  }
};

export const getCustomerHouseholdData = async (): Promise<any> => {
  if (settings['mockedMode']) return mockHouseholdData;

  return HouseholdService.http.get('', {
    errorCodes,
    handleServiceResponse
  });
};

export const getCustomerHouseholdDataById = async (
  businessPartnerId
): Promise<any> => {
  const payload = businessPartnerId && { businessPartnerId };
  return HouseholdService.http.post('', payload, {
    errorCodes,
    handleServiceResponse
  });
};

export const getCustomerHouseholdDataByTaxId = async (
  taxIdInfo
): Promise<any> => {
  return HouseholdByTaxIdService.http.post('', taxIdInfo, {
    errorCodes,
    handleServiceResponse
  });
};

export const getCustomerHouseholdTierData = async (): Promise<any> => {
  return HouseholdTierService.http.get('', {
    errorCodes,
    handleServiceResponse
  });
};

export const getCustomerHouseholdBalanceTierData = async (): Promise<any> => {
  return HouseholdBalanceTierService.http.get('', {
    errorCodes,
    handleServiceResponse
  });
};

export default HouseholdService;
